import { render, staticRenderFns } from "./TopPanel.vue?vue&type=template&id=20a2e57e&scoped=true&"
import script from "./TopPanel.vue?vue&type=script&lang=js&"
export * from "./TopPanel.vue?vue&type=script&lang=js&"
import style0 from "./TopPanel.vue?vue&type=style&index=0&id=20a2e57e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a2e57e",
  null
  
)

export default component.exports